import React, { useEffect, useState } from "react";
import styles from './meetingdetailssummary.module.scss'
import { ccTabChange, storeMOM, storeWindowState ,setSearchKey, storeTranscript, storeActions, storePerformance} from "../../../../base/meetingService/meetingStoreServices";
import { Dropdown, Form, Menu, Modal, Popover, Radio, Select, Tabs, Tooltip, Checkbox } from "antd";
import MeetingSummary from "./meetingsummary";
import MeetingTranscript from "./meetingtranscript";
import MeetingHighlights from "./meetinghighlights";
import { URAvatarGroup } from "../../../../shared/widgets/avatarGroup";
import { URStatusDot } from "../../../../shared/widgets/avatarGroup/statusDot";
import store from "../../../../context/store/store";
import { useSelector } from "react-redux";
import { copyCC, getMOM, searchHandler, searchHighlight, textToPdf, textToText, textToWord, updateCCToast, userStatusColor } from "../../../../base/callService/common";
import _ from "lodash";
import { URInput } from "../../../../shared/widgets/input";
import { URInputwithLabel } from "../../../../shared/widgets/inputwithLable";
import JSZip from 'jszip';
import MeetingKeywords from "./meetingKeywords";
import MeetingActions from "./meetingActions";
import { UserDetails } from "../../../../models/model";
const { Option } = Select;
const zip = new JSZip();
type MeetingDetailsMOM = {
  download: any;
  allContacts: any;
  favouriteContacts: any;
  searchKey: string;
  shareUrl: any;
  shareContact: any;
  editModal: boolean;
  isShareModal: Boolean;
  isDownloadModal: boolean;
  share: string;
  fileFormat: string;
  fileType: any;
  textVal: any;
  changeInputState: boolean;
  title: string;
  externalKey: any;
  searchIcon: boolean;
  searchVal:string;
  checked:any;
  shareCon:any;
};

type MeetingDetailMOMProps={
  scrollValue:boolean;
}

export default function MeetingDetailsSummary({scrollValue}:MeetingDetailMOMProps) {
  let { meetingReducer, contactReducer }: any = useSelector((state: any) => state);
  let { detailPage,  ccTab,editMOM,transcript,meetingHighlights,actionsData,planBased ,part_MOM,momLoad} = store.getState().meetingReducer;
  let { workContacts, favContacts } = contactReducer;
  const [getData, setData] = useState<MeetingDetailsMOM>({
    download: "", allContacts: workContacts, favouriteContacts: favContacts, searchKey: "", shareUrl: [], shareContact: [],
    editModal: false, isShareModal: false, isDownloadModal: false, share: "internal", fileFormat: "pdf", fileType: [], textVal: "", changeInputState: false, title: detailPage.title, externalKey: "Gmail",
    searchIcon: false,searchVal:"",checked:[],shareCon:[]
  });

  const AISummaries = planBased.find((item:any) => item.featureid === 461);
    const AIKeywords = planBased.find((item:any) => item.featureid === 450);
    const AITranscripts = planBased.find((item:any) => item.featureid === 23);
    const AIdrivenActionItems = planBased.find((item:any) => item.featureid === 492);
    const AImeetingHighlights = planBased.find((item:any) => item.featureid === 31);

  const [aISummariesBtn, setAISummariesBtn] = useState(false)
  const [aIKeywordsBtn, setAIKeywordsBtn] = useState(false)
  const [aITranscriptsBtn, setAITranscriptsBtn] = useState(false)
  const [aImeetingHighlightsBtn, setAImeetingHighlightsBtn] = useState(false)
  const [aIdrivenActionItemsBtn, setAIdrivenActionItemsBtn] = useState(false)

  useEffect(() => {
    storeMOM([],[],[],[],true);
    storeTranscript([],false,0);
    storeActions([],false,0)
    storePerformance([],false,0);
    setData({...getData,searchVal:"",searchIcon: false});
    // searchTrancript("", detailPage.uuid);
    getMOM();
  }, [JSON.stringify(detailPage.uuid)])

  useEffect(() => {
   console.log("Plan bAsed useEffect")
    // {AISummaries}
    if (AISummaries && AISummaries.value1 === "Yes") {
      setAISummariesBtn(false); 
    } else {
      setAISummariesBtn(true);
    }

     // {AIKeywords}
    if (AIKeywords && AIKeywords.value1 === "Yes") {
      setAIKeywordsBtn(false); 
    } else {
      setAIKeywordsBtn(true);
    }

     // {AITranscripts}
     if (AITranscripts && AITranscripts.value1 === "Yes") {
       setAITranscriptsBtn(false); 
     } else {
       setAITranscriptsBtn(true);
     }
 
      // {AI_meeting_highlights}
     if (AImeetingHighlights && AImeetingHighlights.value1 === "Yes") {
       setAImeetingHighlightsBtn(false); 
     } else {
       setAImeetingHighlightsBtn(true);
     }

      // {AIdriven_action_items}
    if (AIdrivenActionItems && AIdrivenActionItems.value1 === "Yes") {
      setAIdrivenActionItemsBtn(false); 
    } else {
      setAIdrivenActionItemsBtn(true);
    }
  
  }, [planBased]); 

  const shareModal = () => { setData({ ...getData, isShareModal: true,title:detailPage.title }) }
  const closeShare = () => { setData({ ...getData, isShareModal: false, fileType: [], fileFormat: "pdf",checked:[],shareContact:[],shareCon:[],externalKey:"Gmail",title:detailPage.title ,share:"internal"}) }
  const externalShare = () => {
    if (getData.fileFormat === "pdf") { textToPdf(getData.fileType, "external", getData.title, getData.shareContact, getData.externalKey); }
    else if (getData.fileFormat === "word") { textToWord(getData.fileType, "external", getData.title, getData.shareContact, getData.externalKey); }
    else { textToText(getData.fileType, "external", getData.title, getData.shareContact, getData.externalKey); }
    setData({ ...getData, isShareModal: false, fileType: [], fileFormat: "pdf",externalKey:"Gmail",checked:[],share:"internal",shareCon:[],shareContact:[] })
  }
  const shareSummary = () => {
    if (getData.fileType.length === 0) {
      updateCCToast("Please select a file type to share the file");
      return;
    }
    if (getData.shareContact.length === 0) {
      updateCCToast("Please select a contact to share the file");
      return;
    }
    if(getData.title === ""){
      updateCCToast("Please enter file name to share the file");
      return;
    }
    else if (getData.shareContact.length > 0 && getData.fileType.length > 0) {
      if (getData.fileFormat === "pdf") { textToPdf(getData.fileType, "share", getData.title, getData.shareContact,getData.externalKey); }
      else if (getData.fileFormat === "word") { textToWord(getData.fileType, "share", getData.title, getData.shareContact,getData.externalKey); }
      else { textToText(getData.fileType, "share", getData.title, getData.shareContact,getData.externalKey); }
      setData({ ...getData, isShareModal: false, fileType: [], fileFormat: "pdf",checked:[],shareContact:[],shareCon:[],share:"internal",externalKey:"Gmail"})
    }
  }


  const downloadModal = () => { setData({ ...getData, isDownloadModal: true,title:detailPage.title }) }

  const closeDownload = () => { setData({ ...getData, isDownloadModal: false, fileType: [], fileFormat: "pdf",checked:[],shareCon:[],shareContact:[],title:detailPage.title}) }


  const fileSelect = (e: any) => {
    let type: any;
    switch (e.target.value) {
      case 1:
        type = "pdf";
        break;
      case 2:
        type = "word";
        break;
      case 3:
        type = "text";
        break;
      default:
        type = "pdf";
        break;
    }
    setData({ ...getData, fileFormat: type })
  }

  const selectFile = (e: any) => {
    setData({ ...getData, fileType: e,checked:e })
  }

  const download = () => {
    if(getData.title === ""){
      updateCCToast("Please enter file name to share the file");
      return;
    }
    if (getData.fileType.length === 0) {
      updateCCToast("Please select a file type to share the file");
      return;
    }
    if (getData.fileFormat === "pdf") { textToPdf(getData.fileType, "download", getData.title); }
    else if (getData.fileFormat === "word") { textToWord(getData.fileType, "download", getData.title); }
    else { textToText(getData.fileType, "download", getData.title); }
    closeDownload();
  }

  const searchContact = (e: string) => {
    let searchName = e.toLowerCase();
    if (searchName !== "") {
      let filtered = _.filter(getData.allContacts, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      let filteredFav = _.filter(favContacts, function (name: any) {
        return name.caller_id?.toLowerCase().includes(searchName) ||
          name.ext?.toString().includes(searchName) || name.team_name?.includes(searchName) ||
          name.email_id?.toLowerCase().includes(searchName);
      });
      setData({ ...getData, allContacts: filtered, searchKey: searchName, favouriteContacts: filteredFav });
    }
    else { setData({ ...getData, allContacts: workContacts, searchKey: searchName, favouriteContacts: favContacts }); }
  };

  const shareMode = (e: any) => {
    let type: any = "";let sharetype:any="";
    if (e.target.value === 1) {
      type = "internal"
    }
    else {
      type = "external"
    }
    setData({ ...getData, share: type,externalKey:sharetype })
  }

  const selectContact = (val: any, obj: any) => {
    try {
      var filtered_array = [];
      for (var i = 0; i < obj.length; i++) {
        let data: any = JSON.parse(obj[i].key);
        let item = {
          sipid: data.sip_login_id,
          name: data.caller_id,
          ext: data.ext,
          profile_img: data.ImageURL,
          email: data.email_id,
          roletype: 3,
          user_type: "company",
          jid: data.jid
        };
        filtered_array.push(item);
      }
      setData({ ...getData, shareContact: filtered_array,shareCon:val });
    }
    catch (e: any) {
      console.log("selectBoxOnchange >>>>>", e)
    }
    
  }
  const changeFileName = (e: any) => {
    setData({ ...getData, title: e.target.value })
  }

  const getInitialActiveKey = () => {
    console.log("getInitialActiveKey")

    if (AISummaries && AISummaries.value1 === "Yes") {
      return "1";
    } else if (AIKeywords && AIKeywords.value1 === "Yes") {
      return "2";
    } else if (AITranscripts && AITranscripts.value1 === "Yes") {
      return "3";
    } else if (AImeetingHighlights && AImeetingHighlights.value1 === "Yes") {
      return "4";
    }
    else if (AIdrivenActionItems && AIdrivenActionItems.value1 === "Yes") {
      return "5";
    }
    return null;
  };

  const [activeKey, setActiveKey] = useState(getInitialActiveKey());

  useEffect(() => {
    console.log("Useeffect")
    setActiveKey(getInitialActiveKey());
  }, [planBased]);
console.log("activeKey",activeKey)
  const handleTab = (key:any) => {
    console.log("handleTab")
    if ((key === "1" && aISummariesBtn)) {
      const newActiveKey = getInitialActiveKey();
      console.log("newActiveKey",newActiveKey)
      setActiveKey(newActiveKey);
      ccTabChange(newActiveKey);
      return;
    }
    else
    {
      setActiveKey(key);
      ccTabChange(key);
      setSearchKey("");
    }

  };

  const commonCopy = () => {
    copyCC();
  }

  const displaySearch = () => {
    setData({ ...getData, searchIcon: true });
  }


  const externalChangeKey = (e: any) => {
    setData({ ...getData, externalKey: e.key });
  }

  const changeSearch=(e:any)=>{
setData({...getData,searchVal:e.target.value})
setSearchKey(e.target.value);
  }

  const clearInput=()=>{
    setData({...getData,searchVal:"",searchIcon: false})
    setSearchKey("");
  }

  const mailType = (
    <div className={`nativelaug `}>
      <Menu className=" timezonelist scroller" onClick={externalChangeKey}>
        <Menu.Item key={'Gmail'}>
          <span className="laugname active">Gmail</span>
        </Menu.Item>
        <Menu.Item key={'Outlook'}>
          <span className="laugname">Outlook</span>
        </Menu.Item>
      </Menu>
    </div>
  );
  let resContact: any = searchHandler(workContacts, getData.searchKey);
  let len = Math.round((resContact?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();

  const plainOptions = ['Summary', 'Transcript', 'Highlight','Action Items'];
  const elwidth: any = document.getElementById("tab")?.offsetWidth;

  useEffect(()=>{
    document.documentElement.style.setProperty('--tabdynamicwidth', `${elwidth}px`); 
  },[elwidth])
  const operations = (
    <div className={`fixediconnone ${styles.navrighticons}`}>
      <ul>
            <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Copy'}>
          <span className="icon_copydoc" onClick={commonCopy}></span></Tooltip></li>
        <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Share'}>
          <span className="icon_reply" onClick={shareModal}></span></Tooltip></li>
        <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Download'}>
          <span className="icon_Downloadstroke" onClick={downloadModal}></span></Tooltip></li>
        <li><Tooltip mouseEnterDelay={0.5} placement="top" title={'Search'}>
          <span className="icon_zoom" onClick={displaySearch}></span></Tooltip></li>
      </ul>
    </div>
  );
  
  let loggedUserDetails: UserDetails = store.getState().loginReducer.userdetails || [];
  let actionDataArr = [];
  if (loggedUserDetails?.sip_login_id === detailPage?.sip_id) 
      {
        actionDataArr = actionsData?.slice();
      } 
      else 
      {
        let value = detailPage?.participants?.find((elem:any) => {
  
          return elem?.sipid === loggedUserDetails?.sip_login_id
  
          });
        if(value)
        { 
          let data = actionsData?.find((elem:any) => {
            return elem?.name === loggedUserDetails?.caller_id
          });
          if (data) actionDataArr?.push(data);
        }
        else
        {
          console.log("can't find the data")
        }
  
      }
  return (
    <>

      <div className={styles.meetingsummaryscreen}>
        <div className={styles.tabcontentsecmain}>
        <div className={getData.searchIcon ? `${styles.topsearchtab} ${styles.searchshow} ${scrollValue ? 'fixedSearch' : "" }` : styles.topsearchtab}>
            <div className={styles.searchBoxlefts}>
              <div className={styles.lefts}>
                <Tooltip mouseEnterDelay={0.5} placement="top" title={'Search Chats'}>
                  <span className="icon_zoom"></span>
                </Tooltip>
                <div className={getData.searchIcon ? styles.searchTextChat : `searchAlign ${styles.searchTextChat}`}>
                  <URInputwithLabel placeHolder={"Search"}
                    className="inputBox" id="inputBox" onChange={changeSearch} value={getData.searchVal}/>
                </div>
              </div>
              <div className={styles.rights}>
                <ul>
                  <li className={styles.linkIconsLine}><span></span></li>
                  <li className={styles.linkIcons}><span className="icon_close" onClick={clearInput}></span></li>
                </ul>
              </div>
            </div>
          </div>

          <Tabs className={`customsummarytab moredropnone bgnewtab 
              ${styles.summaryconsectop}`}
            tabPosition="top" activeKey={activeKey}
            tabBarExtraContent={(editMOM && transcript && meetingHighlights) ? operations : ""}
            onChange={handleTab} id="tab"
            >
            <Tabs.TabPane tab="Summary" key="1" disabled={aISummariesBtn}>
              <MeetingSummary />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Keywords" key="2" disabled={aIKeywordsBtn}>
              <MeetingKeywords />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Transcript" key="3" disabled={aITranscriptsBtn}>
              <MeetingTranscript />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Highlights" key="4" disabled={aImeetingHighlightsBtn}>
              <MeetingHighlights />
            </Tabs.TabPane>

            { (actionDataArr && actionDataArr.length > 0 )&&
              <Tabs.TabPane tab="Action Items" key="5" disabled={aIdrivenActionItemsBtn}>
              <MeetingActions/>
            </Tabs.TabPane>
            }
          </Tabs>
        </div>
        <Modal title="Share"
          centered
          visible={getData.isShareModal}
          onCancel={closeShare}
          onOk={getData.share === "internal" ? shareSummary : externalShare}
          cancelText="Cancel"
          okText="Share"
          width="493px"
          cancelButtonProps={{ className: 'urButton buttonWhite' }}
          okButtonProps={{ className: 'urButton buttonBlue' }} className={`customPopup dateicon  borderbtmset`}>
          <div className={styles.insideicon}>
            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>File Name</label>
                <div className={styles.inputconsec}>
                  <URInput placeHolder="Meeting_Title_Summary" name="" className="inputcustomBox"
                    maxLength={80} onChange={changeFileName} value={getData.title} />
                </div>
              </div>
            </div>
            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>File Contains</label>
                <div>
                  <Checkbox.Group options={plainOptions} value={getData.checked} onChange={selectFile} />
                </div>

              </div>
            </div>

            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>Format</label>
                <Form.Item>
                  <Radio.Group defaultValue={1} value={getData.fileFormat === "pdf" ? 1 : getData.fileFormat ==="word" ? 2 : 3} onChange={fileSelect}>
                    <Radio value={1} ><span className={styles.radiosmalltxt}>PDF</span></Radio>
                    <Radio value={2}><span className={styles.radiosmalltxt}>Word</span></Radio>
                    <Radio value={3}><span className={styles.radiosmalltxt}>Text</span></Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>
            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>Export</label>
                <Form.Item>
                  <Radio.Group defaultValue={1}  value={getData.share === "internal" ? 1 : 2} onChange={shareMode}>
                    <Radio value={1} ><span className={styles.radiosmalltxt}>Contact Book</span></Radio>
                    <Radio value={2}><span className={styles.radiosmalltxt}>External Contact</span></Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>

            {getData.share === "internal" && <div className={styles.contactdropconsec}>
              {/* <label>Contact</label> */}
              <div className={styles.insideicon}>
                <Select
                  mode="multiple"
                  style={{ width: '100%' }}
                  filterOption={false}
                  className="newselects taskcreations customdropbox inputselectlftnone"
                  dropdownClassName="newChatSel meetingdropdown"
                  showSearch={true}
                  onSearch={searchContact}
                  placeholder="No assignee"
                  onChange={selectContact}
                  value={getData.shareCon}
                >
                  {(favContacts?.length > 0) &&
                    <div className="titlesdrop">Favourite / Frequently Contacted</div>}
                  {favContacts?.map((favcontactName: any, index: any) => {

                    return <div key={index} value={favcontactName.sip_login_id}>

                      <div className="dropdowndesign">
                        <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                          profileInfo={
                            (favcontactName.ImageURL !== null && favcontactName.ImageURL !== "") ?
                              (<>
                                <img src={favcontactName.ImageURL} alt="" />
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} /></>) :
                              (<>
                                <span>{favcontactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                <URStatusDot className={userStatusColor(favcontactName.user_status, 'small')} />
                              </>)
                          } />
                        <div className="names">{favcontactName.caller_id}</div>
                        <div className="ext">{favcontactName.ext}</div>
                      </div>
                    </div>;
                  })}
                  {getData.allContacts?.map((contactName: any, index: any) => {


                    let highlighted: any = searchHighlight(contactName, getData.searchKey);
                    return <Option key={JSON.stringify(contactName)} value={contactName.sip_login_id}>
                      {
                        ((getData.allContacts[index - 1]?.caller_id)?.charAt(0).toUpperCase()) !==
                        ((contactName?.caller_id)?.charAt(0).toUpperCase()) &&
                        <div className="titlesdrop">{(contactName?.caller_id)?.charAt(0).toUpperCase()} </div>
                      }
                      <div className="dropdowndesign">
                        <div className="usergroupss">
                          <URAvatarGroup className={`lefts size22 colorBG${random_color[index]}`}
                            profileInfo={
                              (contactName.ImageURL !== null && contactName.ImageURL !== "") ?
                                (<>
                                  <img src={contactName.ImageURL} alt="" className={styles.imgSelected} />
                                  <URStatusDot className={userStatusColor(contactName.user_status, 'small')} /></>) :
                                (<>
                                  <span>{contactName?.caller_id?.charAt(0).toUpperCase()} </span>
                                  <URStatusDot className={userStatusColor(contactName.user_status, 'small')} />
                                </>)
                            } />
                        </div>
                        {getData.searchKey !== '' ?
                          <div className="names">{(highlighted?.middleMsg !== "") ? (<>{highlighted?.firstMsg}
                            <b className={styles.highlight}>{highlighted?.middleMsg}</b>
                            {highlighted?.lastMsg}</>) :
                            (<>{contactName?.caller_id}</>)}</div> :
                          <div className="names">{contactName.caller_id}</div>}
                        <div className="ext">{contactName.ext}</div>
                      </div>
                    </Option>;
                  })}
                </Select>
              </div>
            </div>}
            {getData.share === "external" &&
              <div className={styles.shareSelect}>
                <Dropdown overlay={mailType} placement="bottomRight" trigger={['click']}>
                  <div className={`${styles.timezone} ${styles.editStatus} ${styles.nativelaug}`}>
                    <div className={styles.langSelSec}>
                      <span>{getData.externalKey}</span>
                      <span className="icon_downarrow2" ></span>
                    </div>

                  </div>
                </Dropdown>
              </div>
            }
          </div>
        </Modal>
        
        <Modal title="Download"
          centered
          visible={getData.isDownloadModal}
          onCancel={closeDownload}
          onOk={download}
          cancelText="Cancel"
          okText="Download"
          width="493px"
          cancelButtonProps={{ className: 'urButton buttonWhite' }}
          okButtonProps={{ className: 'urButton buttonBlue' }} className="customPopup dateicon borderbtmset" >
          <div className={styles.insideicon}>
            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>File Name</label>
                <div className={styles.inputconsec}>
                  <URInput placeHolder="Meeting_Title_Summary" name="" className="inputcustomBox"
                    maxLength={80} onChange={changeFileName} value={getData.title} />
                </div>
              </div>
            </div>
            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>File Contains</label>
                <div>
                  <Checkbox.Group value={getData.checked} options={plainOptions} onChange={selectFile} />
                </div>

              </div>
            </div>
            <div className={styles.half}>
              <div className={styles.radiobuttonsec}>
                <label className={styles.formlabel}>Format</label>
                <Form.Item>
                  <Radio.Group defaultValue={1}  value={getData.fileFormat === "pdf" ? 1 : getData.fileFormat ==="word" ? 2 : 3}  onChange={fileSelect}>
                    <Radio value={1} ><span className={styles.radiosmalltxt}>PDF</span></Radio>
                    <Radio value={2}><span className={styles.radiosmalltxt}>Word</span></Radio>
                    <Radio value={3}><span className={styles.radiosmalltxt}>Text</span></Radio>
                  </Radio.Group>
                </Form.Item>
              </div>
            </div>
          </div>

        </Modal>
      </div>

    </>
  );
};

